<template>
  <b-card>
    <!-- form -->
    <validation-observer
      ref="changePasswordForm"
      #default="{ invalid }"
    >
      <b-form @submit.prevent="submit">
        <b-row>
          <!-- new password -->
          <b-col md="6">
            <b-form-group
              label-for="password"
              :label="$t('Password')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Password')"
                vid="password"
                rules="required"
              >
                <b-input-group class="input-group-merge">

                  <b-form-input
                    id="password"
                    v-model="form.password"
                    :type="passwordFieldTypeNew"
                    :state="errors.length > 0 ? false : null"
                    name="password"
                    :placeholder="$t('Password')"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconNew"
                      class="cursor-pointer"
                      @click="togglePasswordNew"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ new password -->

          <!-- retype password -->
          <b-col md="6">
            <b-form-group
              label-for="password-confirmation"
              :label="$t('Password Confirmation')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Password Confirmation')"
                vid="password-confirmation"
                rules="required|confirmed:password"
              >
                <b-input-group class="input-group-merge">

                  <b-form-input
                    id="password-confirmation"
                    v-model="form.password_confirmation"
                    :type="passwordFieldTypeRetype"
                    :state="errors.length > 0 ? false : null"
                    name="password-confirmation"
                    :placeholder="$t('Password Confirmation')"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconRetype"
                      class="cursor-pointer"
                      @click="togglePasswordRetype"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ retype password -->

          <!-- buttons -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1 mr-1"
            >
              {{ $t('Save changes') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
              class="mt-1"
            >
              {{ $t('Reset') }}
            </b-button>
          </b-col>
        <!--/ buttons -->
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        password: '',
        password_confirmation: '',
      },
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      // validation rules
      required,
    }
  },
  computed: {
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    submit() {
      this.$refs.changePasswordForm.validate().then(success => {
        if (success) {
          return this.$emit('onFormSubmit', this.form)
        }
        return success
      })
    },
  },
}
</script>
